/* global Swiper */

import 'whatwg-fetch';
import inView from 'in-view';

const projects = Array.from(document.querySelectorAll('.project-wrapper'));
const project = document.querySelector('.project');
const projectFilter = document.querySelector('.project-list-filter');
const projectFilterShowButton = document.querySelector('.project-filter-show');
const projectFilterCloseButton = document.querySelector('.project-filter-close');
const projectPagination = Array.from(document.querySelectorAll('a[rel="prev"], a[rel="next"]'));
const documentTitleSuffix = document.title.split('–').pop().trim();
const parser = new DOMParser();
const duration = 700;
const canvas = document.createElement('canvas');
let startTime = null;
let length;
let loaded = false;

canvas.classList.add('project-transition-overlay');

function rotateOut(time) {
  if (!startTime) {
    startTime = time;
  }
  const delta = Math.min(1, (time - startTime) / duration);
  const deltaSquare = Math.min(2 * delta, 1) * Math.min(2 * delta, 1);
  const paginationOverview = document.querySelector('.project-pagination-overview');
  const positionTop = (canvas.height / 2) - paginationOverview.getBoundingClientRect().top - 30;
  const ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  ctx.fillStyle = 'white';
  ctx.strokeStyle = '#cdcdcd';
  ctx.beginPath();

  ctx.save();
  ctx.translate(-canvas.width, canvas.height / 2);
  ctx.rotate(-(Math.PI / 2) - ((Math.PI / 2) * delta * delta));

  ctx.moveTo(-length / 2, 0);
  ctx.lineTo(-canvas.width, 4 * canvas.height);
  ctx.lineTo(canvas.width, 4 * canvas.height);
  ctx.lineTo(length / 2, 0);
  ctx.closePath();

  ctx.restore();

  ctx.fill();
  ctx.stroke();

  ctx.save();

  ctx.fillStyle = `rgba(245, 245, 245, ${delta < 0.5 ? 1 : 1 - (delta * delta)})`;
  ctx.translate(canvas.width / 2, (canvas.height / 2) - (deltaSquare * positionTop));
  ctx.scale(3 - (2 * deltaSquare), 3 - (2 * deltaSquare));
  ctx.beginPath();
  ctx.moveTo(-30, -30);
  ctx.lineTo(30, -30);
  ctx.lineTo(30, 30);
  ctx.lineTo(-30, 30);
  ctx.closePath();
  ctx.fill();

  ctx.restore();

  [-10, 0, 10].forEach((x) => {
    [-10, 0, 10].forEach((y) => {
      ctx.save();
      ctx.fillStyle = `rgba(137, 168, 28, ${deltaSquare < 0.5 ? 1 : 1 - (deltaSquare * deltaSquare)}`;
      ctx.translate(canvas.width / 2, (canvas.height / 2) - (deltaSquare * positionTop));
      ctx.scale(3 - (2 * deltaSquare), 3 - (2 * deltaSquare));
      ctx.beginPath();
      ctx.moveTo(x - 3, y - 3);
      ctx.lineTo(x + 3, y - 3);
      ctx.lineTo(x + 3, y + 3);
      ctx.lineTo(x - 3, y + 3);
      ctx.closePath();
      ctx.fill();
      ctx.restore();
    });
  });

  if (delta < 1) {
    requestAnimationFrame(rotateOut);
  } else {
    startTime = null;
  }
}

function animateLoader(time) {
  if (!startTime) {
    startTime = time;
  }
  const delta = (time - startTime) / 100;

  const ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  ctx.fillStyle = 'white';
  ctx.beginPath();

  ctx.save();
  ctx.moveTo(0, 0);
  ctx.lineTo(canvas.width, 0);
  ctx.lineTo(canvas.width, canvas.height);
  ctx.lineTo(0, canvas.height);
  ctx.closePath();

  ctx.restore();

  ctx.fill();

  ctx.save();
  ctx.fillStyle = 'rgb(245, 245, 245)';
  ctx.translate(canvas.width / 2, canvas.height / 2);
  ctx.scale(3, 3);
  ctx.beginPath();
  ctx.moveTo(-30, -30);
  ctx.lineTo(30, -30);
  ctx.lineTo(30, 30);
  ctx.lineTo(-30, 30);
  ctx.closePath();
  ctx.fill();
  ctx.restore();

  [-10, 0, 10].forEach((x) => {
    [-10, 0, 10].forEach((y) => {
      ctx.save();
      ctx.fillStyle = `rgba(137, 168, 28, ${(Math.cos(delta / 2) / 2) + 0.5})`;
      ctx.translate(canvas.width / 2, canvas.height / 2);
      ctx.scale(3, 3);
      ctx.beginPath();
      ctx.moveTo(x - 3, y - 3);
      ctx.lineTo(x + 3, y - 3);
      ctx.lineTo(x + 3, y + 3);
      ctx.lineTo(x - 3, y + 3);
      ctx.closePath();
      ctx.fill();
      ctx.restore();
    });
  });

  if (!loaded) {
    requestAnimationFrame(animateLoader);
  } else {
    startTime = null;
    requestAnimationFrame(rotateOut);
  }
}

function rotateIn(time) {
  let index = 0;

  if (!startTime) {
    startTime = time;
  }
  const delta = Math.min(1, (time - startTime) / duration);

  const ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  ctx.fillStyle = 'white';
  ctx.strokeStyle = '#cdcdcd';
  ctx.beginPath();

  ctx.save();
  ctx.translate(-length, canvas.height / 2);
  ctx.rotate(-(Math.PI / 2) * delta * (2 - delta));

  ctx.moveTo(-length / 2, 0);
  ctx.lineTo(-length, 4 * canvas.height);
  ctx.lineTo(length, 4 * canvas.height);
  ctx.lineTo(length / 2, 0);
  ctx.closePath();

  ctx.restore();

  ctx.fill();
  ctx.stroke();

  ctx.save();
  ctx.fillStyle = `rgba(245, 245, 245, ${delta < 0.5 ? 0 : delta + 0.3})`;
  ctx.translate(canvas.width / 2, (canvas.height / 2) + ((1 - (delta * (2 - delta))) * 150));
  ctx.scale(3, 3);
  ctx.beginPath();
  ctx.moveTo(-30, -30);
  ctx.lineTo(30, -30);
  ctx.lineTo(30, 30);
  ctx.lineTo(-30, 30);
  ctx.closePath();
  ctx.fill();
  ctx.restore();

  [-10, 0, 10].forEach((x) => {
    [-10, 0, 10].forEach((y) => {
      ctx.save();
      ctx.fillStyle = `rgba(137, 168, 28, ${delta < 0.5 + (index / 18) ? 0 : delta})`;
      ctx.translate(canvas.width / 2, (canvas.height / 2) - ((30 * index) - (30 * index * delta * (2 - delta))));
      ctx.scale(3, 3);
      ctx.beginPath();
      ctx.moveTo(x - 3, y - 3);
      ctx.lineTo(x + 3, y - 3);
      ctx.lineTo(x + 3, y + 3);
      ctx.lineTo(x - 3, y + 3);
      ctx.closePath();
      ctx.fill();
      ctx.restore();
      index += 1;
    });
  });

  if (delta < 1) {
    requestAnimationFrame(rotateIn);
  } else {
    startTime = null;
    requestAnimationFrame(animateLoader);
  }
}

projects.forEach((p) => {
  const column = p.querySelector('.project-col-left');
  column.classList.add('transparent');
});

function closeCurtain() {
  canvas.width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  canvas.height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  length = Math.max(canvas.width, canvas.height);
  document.body.appendChild(canvas);

  requestAnimationFrame(rotateIn);
}

function changeProject(data) {
  const body = parser.parseFromString(data.content, 'text/html').querySelector('.project');

  window.scrollTo(0, 0);
  project.innerHTML = body.innerHTML;

          // Update window title
  const newTitle = `${data.title.rendered} – ${documentTitleSuffix}`;
  document.title = newTitle;

  history.pushState(data.id, document.title, data.link);

  Array.from(project.querySelectorAll('.wpb_animate_when_almost_visible')).forEach((element) => {
    element.classList.remove('wpb_animate_when_almost_visible');
  });

  // :not excludes swiper awards and swiper clients
  const containers = document.querySelectorAll('.swiper-container:not([class*="swiper-container-id"])');

  containers.forEach(container => {
    const swiperControls = container.querySelector('.swiper-controls');

    const id = container.dataset.id;

    const swiper = new Swiper(`.swiper-container-${id}`, {
      grabCursor: true,
      autoHeight: true,
      pagination: '.swiper-pagination',
      paginationType: 'fraction',
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
    });

    const setFigCaption = function () {
      const currentSlide = swiper.slides[swiper.activeIndex];
      const figCaption = currentSlide.querySelector('.swiper-figcaption');
      swiperControls.style.top = `${-figCaption.clientHeight}px`;
    };

    window.addEventListener('load', setFigCaption);
    swiper.on('slideChangeStart', setFigCaption);
  });

  Array.from(document.querySelectorAll('a[rel="prev"], a[rel="next"]')).forEach((paginationLink) => {
    paginationLink.addEventListener('click', (event) => {
      event.preventDefault();
      closeCurtain();
      getProject(event.target.dataset.id);
    });
  });

  loaded = true;
  setTimeout(() => {
    document.body.removeChild(canvas);
  }, duration);
}

function getProject(projectId) {
  const lang = document.documentElement.lang.split('-').shift();

  loaded = false;

  fetch(`/wp-json/wp/v2/projects/${projectId}?lang=${lang}`)
    .then(blob => blob.json())
    .then((data) => {
      setTimeout(() => {
        changeProject(data);
      }, duration);
    });
}

window.addEventListener('popstate', (event) => {
  if (event.state !== null) {
    closeCurtain();
    getProject(event.state);
  } else {
    window.history.back();
  }
});


projectPagination.forEach((paginationLink) => {
  paginationLink.addEventListener('click', (event) => {
    const viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

    if (viewportWidth >= 768) {
      history.pushState(document.querySelector('#projectId').value, document.title, document.location);
      event.preventDefault();
      closeCurtain();
      getProject(event.target.dataset.id, event.target.rel);
    }
  });
});


inView.offset(window.innerHeight / 3);
inView('.project-wrapper')
  .on('enter', (el) => {
    const column = el.querySelector('.project-col-left');
    el.classList.add('inview');
    column.classList.remove('transparent');
  });

inView.offset(0);
inView('.project-item')
  .on('enter', (el) => {
    el.classList.add('inview');
  });

function showFilter() {
  projectFilter.classList.add('show');
}

function closeFilter() {
  projectFilter.classList.remove('show');
}

if (projectFilterShowButton) {
  projectFilterShowButton.addEventListener('click', showFilter);
}

if (projectFilterCloseButton) {
  projectFilterCloseButton.addEventListener('click', closeFilter);
}



// WEBPACK FOOTER //
// ./scripts/projects.js